<!-- Builder for UniMess-->

<template>
	<div class="uni-mess-bld">
		<div class="title wi8_font">
			Uni Mess Builder &nbsp;
			<button @click="goPop">Popup Message</button>
			</div>
		<div class="content">
			<UniMess :compData="payload.compData"/>
		</div>
	</div>
</template>

<script>
import { eventBus } from '@/main';
export default {
	data() {
		return {
			payload: {
				popType: "win",
				popTitle: "Error from Server",
				compName: "UniMess",
				compData: {
					title: "Message Title Here",
					// messType: "default",
					// messType: "ok",
					// messType: "info",
					// messType: "err",
					messType: "warn",
					// mess: "Steady Liner",
					mess: [
						"Message line 1",
						"Message line 2",
						"Message line 3",
						"Message line 4",
						"Message line 5",
						"Message line 6",
						"Message line 7",
						"Message line 8",
						"Message line 9",
					],
				}
			},

		}
	},
	methods: {
		goPop() {
			eventBus.$emit("popup", this.payload);			
		},
	},
}
</script>

<style scoped>
.uni-mess-bld {
	height: 100%;
	overflow: hidden;
	background-color: #FCFCEE;
	padding: 5px;
	border: solid 0px #009;
}

.title {
	height: 25px;
	overflow: hidden;
	color: #900;
	border: solid 0px #CCC;
}

.content {
	height: calc(100% - 25px);
	overflow: hidden;
	border: solid 0px #090;
}
</style>
